// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************** roles **********************************************************************
const INDEX_PERMISSION_ROLES_SUCCESS = "INDEX_PERMISSION_ROLES_SUCCESS";
const SHOW_PERMISSION_ROLE_SUCCESS = "SHOW_PERMISSION_ROLE_SUCCESS";
const STORE_PERMISSION_ROLE_SUCCESS = "STORE_PERMISSION_ROLE_SUCCESS";
const UPDATE_PERMISSION_ROLE_SUCCESS = "UPDATE_PERMISSION_ROLE_SUCCESS";
const DESTROY_PERMISSION_ROLE_SUCCESS = "DESTROY_PERMISSION_ROLE_SUCCESS";
// ******************************************************************* permissions *******************************************************************
const INDEX_PERMISSIONS_SUCCESS = "INDEX_PERMISSIONS_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************** roles **********************************************************************
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexRolesSuccess(payload) {
  return {
    type: INDEX_PERMISSION_ROLES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _showRoleSuccess(payload) {
  return {
    type: SHOW_PERMISSION_ROLE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _storeRoleSuccess(payload) {
  return {
    type: STORE_PERMISSION_ROLE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _updateRoleSuccess(payload) {
  return {
    type: UPDATE_PERMISSION_ROLE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _destroyRoleSuccess(payload) {
  return {
    type: DESTROY_PERMISSION_ROLE_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************* permissions *******************************************************************
/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _indexPermissionsSuccess(payload) {
  return {
    type: INDEX_PERMISSIONS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {Object} [params]
 * @param {function} [callback=(function())]
 * @return {Function}
 */
export function indexRoles(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Role@index")) {
      api
        .get("/roles", { params })
        .then((res) => {
          dispatch(_indexRolesSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.basic.roles",
            "Role",
            app.translate("routes.home.basic.permission.Indexing Roles Failed")
          );
          callback(err);
        });
    }
  };
}

/**
 * @param {Number} role
 * @param {Object} [params={}]
 * @param {function} [callback=(function())]
 * @return {Function}
 */
export function showRole(role, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Role@index")) {
      api
        .get(`/roles/${role}`, { params })
        .then((res) => {
          dispatch(_showRoleSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.basic.roles",
            "Role",
            app.translate("routes.home.basic.permission.Indexing Role Failed")
          );
          callback(err);
        });
    }
  };
}

/**
 * @param {object} data
 * @param {function} [callback=(function())]
 * @return {Function}
 */
export function storeRole(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Role@store")) {
      let loader = app.loading(
        app.translate("routes.home.basic.permission.Adding new role")
      );

      api
        .post(`/roles`, { data })
        .then((res) => {
          dispatch(_storeRoleSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.basic.permission.New role added successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide();
          app.error(
            err,
            "routes.home.basic.roles",
            "دسترسی با این عنوان از قبل تعریف شده است.",
            app.translate("routes.home.basic.permission.Adding new role failed")
          );
          callback(err);
        });
    }
  };
}

/**
 * @param {Number} role
 * @param {object} data
 * @param {function} [callback=(function())]
 * @return {Function}
 */
export function updateRole(role, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Role@update")) {
      let loader = app.loading(
        app.translate("routes.home.basic.permission.Updating role")
      );
      api
        .put(`/roles/${role}`, { data })
        .then((res) => {
          dispatch(_updateRoleSuccess(res));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.basic.permission.Role updated successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide();
          app.error(
            err,
            "routes.home.basic.roles",
            "دسترسی با این عنوان از قبل تعریف شده است.",
            app.translate("routes.home.basic.permission.Updating role failed")
          );
          callback(err);
        });
    }
  };
}

/**
 * @param {Number} role
 * @param {function} [callback=(function())]
 * @return {Function}
 */
export function destroyRole(role, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Role@destroy")) {
      let loader = app.loading(
        app.translate("routes.home.basic.permission.Removing role")
      );

      api
        .delete(`/roles/${role}`)
        .then((res) => {
          dispatch(_destroyRoleSuccess(role));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.basic.permission.Role removed successfully"
              )
            )
          );
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.basic.roles",
            "Role",
            app.translate("routes.home.basic.permission.Removing role failed")
          );
          callback(err);
        });
    }
  };
}

export function emptyRole() {
  return _showRoleSuccess({ data: { role: {} }, meta: {} });
}

/**
 *
 * @param {Object} [params={}]
 * @param {function} [callback=(function())]
 * @return {Function}
 */
export function indexPermissions(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/permissions", { params })
      .then((res) => {
        dispatch(_indexPermissionsSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        dispatch(_indexPermissionsSuccess(err));
        app.message(
          app.translate(
            "routes.home.basic.permission.Indexing Permissions Failed"
          ),
          "error"
        );
        callback(err);
      });
  };
}

/**
 * @param {Number} roleId
 * @param {object} permissionData
 * @param {object} roleData
 * @param {function} [callback=(function())]
 * @return {Function}
 */
export function updatePermissionsRole(
  roleId,
  permissionData,
  roleData,
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    if (app.can("Role@update")) {
      let loader = app.loading(
        app.translate("routes.home.basic.permission.Updating role")
      );
      api
        .put(`/role/${roleId}/permissions`, {
          data: { permissionRoles: permissionData },
        })
        .then((res) => {
          api.put(`/role/${roleId}/scopes`, { data: roleData }).then((res2) => {
            dispatch(_updateRoleSuccess(res));
            loader.hide(() =>
              app.message(
                app.translate(
                  "routes.home.basic.permission.Role updated successfully"
                )
              )
            );
            callback(undefined, res);
          });
        })
        .catch((err) => {
          loader.hide();
          app.error(
            err,
            "routes.home.basic.roles",
            "Role",
            app.translate("routes.home.basic.permission.Updating role failed")
          );
          callback(err);
        });
    }
  };
}

export function emptyPermissions() {
  return _indexRolesSuccess({ data: { roles: [] }, meta: {} });
}

function _translate(permissions, preTranslateText) {
  let name = "";
  app._.map(permissions, (permission) => {
    if (permission.name || permission.title) {
      // name = permission.name ? permission.name.split('@') : permission.title.split('@');
      // name = name[1] || name[0];
      name = permission.name ? permission.name : permission.title;
      permission["title"] = app.translate(
        `routes.home.basic.permission.${
          preTranslateText ? preTranslateText + "_" : ""
        }${name}`
      );
    }
    if (!app._.isEmpty(permission.nestedChildren)) {
      permission.nestedChildren = _translate(
        permission.nestedChildren,
        `${preTranslateText ? preTranslateText + "_" : ""}${name}`
      );
    }
    if (!app._.isEmpty(permission.permissions)) {
      permission.permissions = _translate(
        permission.permissions,
        `${preTranslateText ? preTranslateText + "_" : ""}${name}`
      );
    }
  });
  return permissions;
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    roles: [],
    role: {},
    permissions: [],
    meta: {},
  },
  action
) {
  let roles;
  let _index;

  switch (action.type) {
    case INDEX_PERMISSION_ROLES_SUCCESS:
      return Object.assign({}, state, {
        roles: action.payload.data.roles,
        meta: action.payload.meta,
      });
    case SHOW_PERMISSION_ROLE_SUCCESS:
      return Object.assign({}, state, {
        role: action.payload.role,
      });
    case STORE_PERMISSION_ROLE_SUCCESS:
      roles = app._.cloneDeep(state.roles);
      roles.push(action.payload);
      return Object.assign({}, state, {
        roles,
        role: action.payload,
      });
    case UPDATE_PERMISSION_ROLE_SUCCESS:
      roles = app._.cloneDeep(state.roles);
      _index = roles.findIndex((_role) => _role.id === action.payload.id);
      roles[_index] = action.payload;
      return Object.assign({}, state, {
        roles,
        role: action.payload,
      });
    case DESTROY_PERMISSION_ROLE_SUCCESS:
      roles = app._.cloneDeep(state.roles);
      _index = roles.findIndex((_role) => _role.id === action.payload);
      roles.splice(_index, 1);
      return Object.assign({}, state, {
        roles,
      });
    case INDEX_PERMISSIONS_SUCCESS:
      let permissions = _translate(action.payload.permissions, "");
      return Object.assign({}, state, {
        permissions,
      });
    default:
      return state;
  }
}
